import styled from 'styled-components';
import media from 'styled-media-query';
import { generateMedia } from 'styled-media-query';

const customMedia = generateMedia({
  mobile: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  laptopXL: "2560px"
})

export const TitleElement = styled.h1`
  line-height: 130%;
  font-size: 200%; /*2.5rem*/ 
  width: fit-content;

  ${media.greaterThan('medium')`
   font-size: 3.5rem;
 `}

  ${media.greaterThan('large')`
   font-size: 4.5rem;
 `}

  ${customMedia.greaterThan('laptopXL')`
   font-size: 9rem;
 `}

`;


